/**
 * This phone films a table start only when its own camera is on that table
 * and, when the server names devices, this phone is one of them.
 */
export function thisPhoneShouldRecordTable(event, { phoneId, tableNumber } = {}) {
  const table = Number(event?.table_number);
  const mine = Number(tableNumber);
  if (!Number.isFinite(table) || table < 1) return false;
  if (!Number.isFinite(mine) || mine < 1 || mine !== table) return false;
  const id = String(phoneId || "");
  const listed = Array.isArray(event?.device_ids)
    ? event.device_ids.map((value) => String(value || "")).filter(Boolean)
    : [];
  if (!id || listed.length === 0) return true;
  return listed.includes(id);
}
